import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	insertButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidUrlText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	insertButton: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-video-insert.insert-button',
		defaultMessage: 'Insert',
		description:
			'Button text to insert the supplied Loom link. When clicked, it will attach the supplied link to the Jira issue',
	},
	cancelButton: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-video-insert.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Button text to cancel adding a Loom link. When clicked, it will hide the link insertion text field.',
	},
	placeholderText: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-video-insert.placeholder-text',
		defaultMessage: 'Add a Loom link',
		description:
			'Placeholder in text field for adding a Loom link, to prompt the user to paste in a URL',
	},
	invalidUrlText: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-video-insert.invalid-url-text',
		defaultMessage: "Hold on, let's try a valid Loom link instead.",
		description:
			'Validation message informing user that the link does not appear to be a Loom link',
	},
});
export default messages;
